import { BrowserModule } from '@angular/platform-browser';
import { NgModule, ModuleWithProviders } from '@angular/core';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CommonModule } from '@angular/common';
import { NguiAutoCompleteModule } from '@ngui/auto-complete';
import { SelectDropDownModule } from 'ngx-select-dropdown';
import { NgPipesModule } from 'ngx-pipes';
import { TruncateModule } from '@yellowspot/ng-truncate';

import { ProjectmanagementComponent } from './projectmanagement/projectmanagement.component';

/* Import auth guard service */
import { AuthGuard } from '../../../../src/app/auth/auth.guard';
/* Import token interceptor */
import { TokenInterceptor } from '../../../../src/app/auth/token.interceptor';

/* Import translate modules */
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { ToolsModule } from '../../../tools/src/lib/tools.module';
import { ProjectoverviewComponent } from './projectmanagement/projectoverview/projectoverview.component';
import { AddnewprojectComponent } from './projectmanagement/projectadd/addnewproject.component';
import { CtlProjectInfoDetail } from './projectmanagement/projectadd/projectdetails/CtlProjectInfoDetail.directive';

import { CtlUserForm } from './forms/user/CtlUserForm';
import { CtlProjectForm } from './forms/project/ctl.project.form.component';

import { PaschooladminComponent } from './projectsetup/paschooladmin/paschooladmin.component';
import { ProjectGradeComponent} from '../../src/app/forms/projectGrade/ctl.project.grade.component';
import { ProjectSubjectComponent} from '../../src/app/forms/projectSubject/ctl.project.subject.component';
import { SetupreviewComponent } from './projectsetup/setupreview/setupreview.component';

import { ToolsService } from '../../../tools/src/lib/tools.service';

@NgModule({
  declarations: [
    AppComponent,
    ProjectmanagementComponent,
    ProjectoverviewComponent,
    AddnewprojectComponent,
    CtlProjectInfoDetail,
    CtlUserForm,
    CtlProjectForm,
    PaschooladminComponent,
    ProjectGradeComponent,
    ProjectSubjectComponent,
    SetupreviewComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    SelectDropDownModule,
    FormsModule,
    ReactiveFormsModule,
    NgPipesModule,
    ToolsModule,
    NguiAutoCompleteModule,
    TruncateModule,
    TranslateModule.forRoot()
  ],
  providers: [
    AuthGuard,
    ToolsService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    }    
  ],
  exports: [
    SelectDropDownModule,
    CommonModule,
    NgPipesModule,
    CtlUserForm,
    CtlProjectForm
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

@NgModule({})
export class ProjectmanagementSharedModule{
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: AppModule,
      providers: []
    };
  }
}
